import { render, staticRenderFns } from "./phoneBottom.vue?vue&type=template&id=b5b4e39e&scoped=true"
import script from "./phoneBottom.vue?vue&type=script&lang=js"
export * from "./phoneBottom.vue?vue&type=script&lang=js"
import style0 from "./phoneBottom.vue?vue&type=style&index=0&id=b5b4e39e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b4e39e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5b4e39e')) {
      api.createRecord('b5b4e39e', component.options)
    } else {
      api.reload('b5b4e39e', component.options)
    }
    module.hot.accept("./phoneBottom.vue?vue&type=template&id=b5b4e39e&scoped=true", function () {
      api.rerender('b5b4e39e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/component/phoneBottom.vue"
export default component.exports